export const EmbedTypes = {
    Normal: 0,
    Iframe: 1,
    NormalWidgetId: 2,
    IframeWidgetId: 3,
    IFramely: 4,
    IframeOnly: 5,
    ReactOnly: 6,
    ReactOnlyWidgetId: 7
};

export const NativePaymentsTypes = {
    credtCard: 0, // values set in backoffice
    applePay: 3,
    googlePay: 1,
    venmo: 2
};

export const CardTypes = {
    oneAction: 1,
    multipleActions: 2,
    targetedMultiAction: 3,
    multiDonation: 4,
    actionChoice: 5
};

export const RepPositions = {
    yes: 'Yes',
    no: 'No',
    unknown: 'Unknown Position',
    unavailable: undefined
};

export const RepAnswerTypes = {
    notAvailable: 0,
    unknown: 1,
    research: 2,
    direct: 3
};

export const RadialAnswerTypes = {
    correct: 0,
    incorrect: 1,
    almost: 2
};

export const ActionTypes = {
    Call: 'call',
    CheckRegistration: 'checkregistration',
    CheckRepPosition: 'checkrepposition',
    Donation: 'donation',
    ElectionReminder: 'electionreminder',
    Email: 'email',
    FindPollingStation: 'findpollingstation',
    Link: 'link',
    Petition: 'petition',
    Poll: 'poll',
    Quiz: 'quiz',
    RecordVideo: 'recordvideo',
    SentimentPoll: 'sentimentpoll',
    Tweet: 'tweet',
    Video: 'video',
    Volunteer: 'volunteer',
    VoteRegistration: 'voteregistration'
};

export const VolunteerQuestionTypes = {
    singleChoice: 0,
    multiChoice: 1,
    singleLine: 2,
    multiLine: 3
};

export const VolunteerOpportunityType = {
    featured: 0,
    private: 1,
    public: 2,
    project: 3
};

export const IssueTypes = [
    {
        id: 1,
        title: 'Education'
    },
    {
        id: 2,
        title: 'Emergency Response'
    },
    {
        id: 3,
        title: 'Environment'
    },
    {
        id: 4,
        title: 'Health'
    },
    {
        id: 5,
        title: 'LGBTQ Rights'
    },
    {
        id: 6,
        title: 'Migration'
    },
    {
        id: 7,
        title: 'Politics'
    },
    {
        id: 8,
        title: 'Poverty'
    },
    {
        id: 9,
        title: 'Racial Justice'
    },
    {
        id: 10,
        title: 'Safety'
    },
    {
        id: 11,
        title: 'Social Justice'
    },
    {
        id: 12,
        title: "Women's Rights"
    }
];

export const CardOrderTypes = {
    nominal: 1,
    conditional: 2
};

export const RepresentativeDetails = {
    Level: {
        Country: 0,
        State: 1
    },
    Role: {
        LegislatorLowerBody: 0,
        LegislatorUpperBody: 1
    }
};

export const AddressSource = {
    userInput: 0,
    ipLocalization: 1
};

export const RacesList = [
    'Asian',
    'Black or African American',
    'Hispanic or Latino',
    'Native American or Alaskan Native',
    'Native Hawaiian or Other Pacific Islander',
    'Other',
    'Two or More Races',
    'White',
    'Decline to State'
];

export const PrefixList = ['Mr.', 'Mrs.', 'Miss', 'Ms.'];

export const SuffixList = ['Jr.', 'Sr.', 'II', 'III', 'IV'];

export const StatesId = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
];

export const StatesAbbreviation = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    DC: 'District Of Columbia',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming'
};

export const DayDropdownValues = () => {
    let day = [];
    for (var i = 1; i <= 31; i++) {
        day.push(i);
    }
    return day;
};

export const MonthDropdownValues = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

export const FullMonths = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

export const YearDropdownValues = () => {
    let year = [];
    for (var i = 18; i < 99; i++) {
        year.push(new Date().getUTCFullYear() - i);
    }
    return year;
};

export const CountryCodes = [
    { code: 'US', value: 'United States' },
    { code: 'AF', value: 'Afghanistan' },
    { code: 'AX', value: '\u00c5land Islands' },
    { code: 'AL', value: 'Albania' },
    { code: 'DZ', value: 'Algeria' },
    { code: 'AS', value: 'American Samoa' },
    { code: 'AD', value: 'Andorra' },
    { code: 'AO', value: 'Angola' },
    { code: 'AI', value: 'Anguilla' },
    { code: 'AQ', value: 'Antarctica' },
    { code: 'AG', value: 'Antigua and Barbuda' },
    { code: 'AR', value: 'Argentina' },
    { code: 'AM', value: 'Armenia' },
    { code: 'AW', value: 'Aruba' },
    { code: 'AU', value: 'Australia' },
    { code: 'AT', value: 'Austria' },
    { code: 'AZ', value: 'Azerbaijan' },
    { code: 'BS', value: 'Bahamas' },
    { code: 'BH', value: 'Bahrain' },
    { code: 'BD', value: 'Bangladesh' },
    { code: 'BB', value: 'Barbados' },
    { code: 'BY', value: 'Belarus' },
    { code: 'BE', value: 'Belgium' },
    { code: 'BZ', value: 'Belize' },
    { code: 'BJ', value: 'Benin' },
    { code: 'BM', value: 'Bermuda' },
    { code: 'BT', value: 'Bhutan' },
    { code: 'BO', value: 'Bolivia, Plurinational State of' },
    { code: 'BQ', value: 'Bonaire, Sint Eustatius and Saba' },
    { code: 'BA', value: 'Bosnia and Herzegovina' },
    { code: 'BW', value: 'Botswana' },
    { code: 'BV', value: 'Bouvet Island' },
    { code: 'BR', value: 'Brazil' },
    { code: 'IO', value: 'British Indian Ocean Territory' },
    { code: 'BN', value: 'Brunei Darussalam' },
    { code: 'BG', value: 'Bulgaria' },
    { code: 'BF', value: 'Burkina Faso' },
    { code: 'BI', value: 'Burundi' },
    { code: 'KH', value: 'Cambodia' },
    { code: 'CM', value: 'Cameroon' },
    { code: 'CA', value: 'Canada' },
    { code: 'CV', value: 'Cape Verde' },
    { code: 'KY', value: 'Cayman Islands' },
    { code: 'CF', value: 'Central African Republic' },
    { code: 'TD', value: 'Chad' },
    { code: 'CL', value: 'Chile' },
    { code: 'CN', value: 'China' },
    { code: 'CX', value: 'Christmas Island' },
    { code: 'CC', value: 'Cocos (Keeling) Islands' },
    { code: 'CO', value: 'Colombia' },
    { code: 'KM', value: 'Comoros' },
    { code: 'CG', value: 'Congo' },
    { code: 'CD', value: 'Congo, the Democratic Republic of the' },
    { code: 'CK', value: 'Cook Islands' },
    { code: 'CR', value: 'Costa Rica' },
    { code: 'CI', value: "C\u00f4te d'Ivoire" },
    { code: 'HR', value: 'Croatia' },
    { code: 'CU', value: 'Cuba' },
    { code: 'CW', value: 'Cura\u00e7ao' },
    { code: 'CY', value: 'Cyprus' },
    { code: 'CZ', value: 'Czech Republic' },
    { code: 'DK', value: 'Denmark' },
    { code: 'DJ', value: 'Djibouti' },
    { code: 'DM', value: 'Dominica' },
    { code: 'DO', value: 'Dominican Republic' },
    { code: 'EC', value: 'Ecuador' },
    { code: 'EG', value: 'Egypt' },
    { code: 'SV', value: 'El Salvador' },
    { code: 'GQ', value: 'Equatorial Guinea' },
    { code: 'ER', value: 'Eritrea' },
    { code: 'EE', value: 'Estonia' },
    { code: 'ET', value: 'Ethiopia' },
    { code: 'FK', value: 'Falkland Islands (Malvinas)' },
    { code: 'FO', value: 'Faroe Islands' },
    { code: 'FJ', value: 'Fiji' },
    { code: 'FI', value: 'Finland' },
    { code: 'FR', value: 'France' },
    { code: 'GF', value: 'French Guiana' },
    { code: 'PF', value: 'French Polynesia' },
    { code: 'TF', value: 'French Southern Territories' },
    { code: 'GA', value: 'Gabon' },
    { code: 'GM', value: 'Gambia' },
    { code: 'GE', value: 'Georgia' },
    { code: 'DE', value: 'Germany' },
    { code: 'GH', value: 'Ghana' },
    { code: 'GI', value: 'Gibraltar' },
    { code: 'GR', value: 'Greece' },
    { code: 'GL', value: 'Greenland' },
    { code: 'GD', value: 'Grenada' },
    { code: 'GP', value: 'Guadeloupe' },
    { code: 'GU', value: 'Guam' },
    { code: 'GT', value: 'Guatemala' },
    { code: 'GG', value: 'Guernsey' },
    { code: 'GN', value: 'Guinea' },
    { code: 'GW', value: 'Guinea-Bissau' },
    { code: 'GY', value: 'Guyana' },
    { code: 'HT', value: 'Haiti' },
    { code: 'HM', value: 'Heard Island and McDonald Islands' },
    { code: 'VA', value: 'Holy See (Vatican City State)' },
    { code: 'HN', value: 'Honduras' },
    { code: 'HK', value: 'Hong Kong' },
    { code: 'HU', value: 'Hungary' },
    { code: 'IS', value: 'Iceland' },
    { code: 'IN', value: 'India' },
    { code: 'ID', value: 'Indonesia' },
    { code: 'IR', value: 'Iran, Islamic Republic of' },
    { code: 'IQ', value: 'Iraq' },
    { code: 'IE', value: 'Ireland' },
    { code: 'IM', value: 'Isle of Man' },
    { code: 'IL', value: 'Israel' },
    { code: 'IT', value: 'Italy' },
    { code: 'JM', value: 'Jamaica' },
    { code: 'JP', value: 'Japan' },
    { code: 'JE', value: 'Jersey' },
    { code: 'JO', value: 'Jordan' },
    { code: 'KZ', value: 'Kazakhstan' },
    { code: 'KE', value: 'Kenya' },
    { code: 'KI', value: 'Kiribati' },
    { code: 'KP', value: "Korea, Democratic People's Republic of" },
    { code: 'KR', value: 'Korea, Republic of' },
    { code: 'KW', value: 'Kuwait' },
    { code: 'KG', value: 'Kyrgyzstan' },
    { code: 'LA', value: "Lao People's Democratic Republic" },
    { code: 'LV', value: 'Latvia' },
    { code: 'LB', value: 'Lebanon' },
    { code: 'LS', value: 'Lesotho' },
    { code: 'LR', value: 'Liberia' },
    { code: 'LY', value: 'Libya' },
    { code: 'LI', value: 'Liechtenstein' },
    { code: 'LT', value: 'Lithuania' },
    { code: 'LU', value: 'Luxembourg' },
    { code: 'MO', value: 'Macao' },
    { code: 'MK', value: 'Macedonia, the Former Yugoslav Republic of' },
    { code: 'MG', value: 'Madagascar' },
    { code: 'MW', value: 'Malawi' },
    { code: 'MY', value: 'Malaysia' },
    { code: 'MV', value: 'Maldives' },
    { code: 'ML', value: 'Mali' },
    { code: 'MT', value: 'Malta' },
    { code: 'MH', value: 'Marshall Islands' },
    { code: 'MQ', value: 'Martinique' },
    { code: 'MR', value: 'Mauritania' },
    { code: 'MU', value: 'Mauritius' },
    { code: 'YT', value: 'Mayotte' },
    { code: 'MX', value: 'Mexico' },
    { code: 'FM', value: 'Micronesia, Federated States of' },
    { code: 'MD', value: 'Moldova, Republic of' },
    { code: 'MC', value: 'Monaco' },
    { code: 'MN', value: 'Mongolia' },
    { code: 'ME', value: 'Montenegro' },
    { code: 'MS', value: 'Montserrat' },
    { code: 'MA', value: 'Morocco' },
    { code: 'MZ', value: 'Mozambique' },
    { code: 'MM', value: 'Myanmar' },
    { code: 'NA', value: 'Namibia' },
    { code: 'NR', value: 'Nauru' },
    { code: 'NP', value: 'Nepal' },
    { code: 'NL', value: 'Netherlands' },
    { code: 'NC', value: 'New Caledonia' },
    { code: 'NZ', value: 'New Zealand' },
    { code: 'NI', value: 'Nicaragua' },
    { code: 'NE', value: 'Niger' },
    { code: 'NG', value: 'Nigeria' },
    { code: 'NU', value: 'Niue' },
    { code: 'NF', value: 'Norfolk Island' },
    { code: 'MP', value: 'Northern Mariana Islands' },
    { code: 'NO', value: 'Norway' },
    { code: 'OM', value: 'Oman' },
    { code: 'PK', value: 'Pakistan' },
    { code: 'PW', value: 'Palau' },
    { code: 'PS', value: 'Palestine, State of' },
    { code: 'PA', value: 'Panama' },
    { code: 'PG', value: 'Papua New Guinea' },
    { code: 'PY', value: 'Paraguay' },
    { code: 'PE', value: 'Peru' },
    { code: 'PH', value: 'Philippines' },
    { code: 'PN', value: 'Pitcairn' },
    { code: 'PL', value: 'Poland' },
    { code: 'PT', value: 'Portugal' },
    { code: 'PR', value: 'Puerto Rico' },
    { code: 'QA', value: 'Qatar' },
    { code: 'RE', value: 'R\u00e9union' },
    { code: 'RO', value: 'Romania' },
    { code: 'RU', value: 'Russian Federation' },
    { code: 'RW', value: 'Rwanda' },
    { code: 'BL', value: 'Saint Barth\u00e9lemy' },
    { code: 'SH', value: 'Saint Helena, Ascension and Tristan da Cunha' },
    { code: 'KN', value: 'Saint Kitts and Nevis' },
    { code: 'LC', value: 'Saint Lucia' },
    { code: 'MF', value: 'Saint Martin (French part)' },
    { code: 'PM', value: 'Saint Pierre and Miquelon' },
    { code: 'VC', value: 'Saint Vincent and the Grenadines' },
    { code: 'WS', value: 'Samoa' },
    { code: 'SM', value: 'San Marino' },
    { code: 'ST', value: 'Sao Tome and Principe' },
    { code: 'SA', value: 'Saudi Arabia' },
    { code: 'SN', value: 'Senegal' },
    { code: 'RS', value: 'Serbia' },
    { code: 'SC', value: 'Seychelles' },
    { code: 'SL', value: 'Sierra Leone' },
    { code: 'SG', value: 'Singapore' },
    { code: 'SX', value: 'Sint Maarten (Dutch part)' },
    { code: 'SK', value: 'Slovakia' },
    { code: 'SI', value: 'Slovenia' },
    { code: 'SB', value: 'Solomon Islands' },
    { code: 'SO', value: 'Somalia' },
    { code: 'ZA', value: 'South Africa' },
    { code: 'GS', value: 'South Georgia and the South Sandwich Islands' },
    { code: 'SS', value: 'South Sudan' },
    { code: 'ES', value: 'Spain' },
    { code: 'LK', value: 'Sri Lanka' },
    { code: 'SD', value: 'Sudan' },
    { code: 'SR', value: 'Suriname' },
    { code: 'SJ', value: 'Svalbard and Jan Mayen' },
    { code: 'SZ', value: 'Swaziland' },
    { code: 'SE', value: 'Sweden' },
    { code: 'CH', value: 'Switzerland' },
    { code: 'SY', value: 'Syrian Arab Republic' },
    { code: 'TW', value: 'Taiwan, Province of China' },
    { code: 'TJ', value: 'Tajikistan' },
    { code: 'TZ', value: 'Tanzania, United Republic of' },
    { code: 'TH', value: 'Thailand' },
    { code: 'TL', value: 'Timor-Leste' },
    { code: 'TG', value: 'Togo' },
    { code: 'TK', value: 'Tokelau' },
    { code: 'TO', value: 'Tonga' },
    { code: 'TT', value: 'Trinidad and Tobago' },
    { code: 'TN', value: 'Tunisia' },
    { code: 'TR', value: 'Turkey' },
    { code: 'TM', value: 'Turkmenistan' },
    { code: 'TC', value: 'Turks and Caicos Islands' },
    { code: 'TV', value: 'Tuvalu' },
    { code: 'UG', value: 'Uganda' },
    { code: 'UA', value: 'Ukraine' },
    { code: 'AE', value: 'United Arab Emirates' },
    { code: 'GB', value: 'United Kingdom' },
    { code: 'UM', value: 'United States Minor Outlying Islands' },
    { code: 'UY', value: 'Uruguay' },
    { code: 'UZ', value: 'Uzbekistan' },
    { code: 'VU', value: 'Vanuatu' },
    { code: 'VE', value: 'Venezuela, Bolivarian Republic of' },
    { code: 'VN', value: 'Viet Nam' },
    { code: 'VG', value: 'Virgin Islands, British' },
    { code: 'VI', value: 'Virgin Islands, U.S.' },
    { code: 'WF', value: 'Wallis and Futuna' },
    { code: 'EH', value: 'Western Sahara' },
    { code: 'YE', value: 'Yemen' },
    { code: 'ZM', value: 'Zambia' },
    { code: 'ZW', value: 'Zimbabwe' }
];

export const PaymentProviders = [
    {
        displayName: 'Venmo',
        id: 2
    },
    {
        displayName: 'Apple Pay',
        id: 3
    },
    {
        displayName: 'Google Pay',
        id: 1
    }
];

export const EUCountryCodes = [
    'BE',
    'BG',
    'CZ',
    'DK',
    'DE',
    'EE',
    'IE',
    'EL',
    'ES',
    'FR',
    'HR',
    'IT',
    'CY',
    'LV',
    'LT',
    'LU',
    'HU',
    'MT',
    'NL',
    'AT',
    'PL',
    'PT',
    'RO',
    'SI',
    'SK',
    'FI',
    'SE',
    'UK' // for now . . .
];

export const PaymentMethod = {
    Braintree: 'Braintree',
    OrgHunter: 'OrgHunter'
};
